<script>
    //import { onMount, onDestroy } from 'svelte';

    let {
        effectFn = () => false,
        //destroyFn = () => false,
    } = $props();
    
    $effect(effectFn);
    
    //onDestroy(destroyFn);
</script>